module.exports = __webpack_public_path__ + "static/media/tip_text_dog_stethoscope_en.d894442e.svg";